import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../App';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';

export const WarrantyTicketModal = ({ rollout, onClose, onSuccess }) => {
  const [form, setForm] = useState({ description: '', appointment_date: '', start_time: '', end_time: '', work_type: 'remote', priority: 'Medium' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const change = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      await axios.post(`${API}/appointments/${rollout.id}/warranty-tickets`, form);
      toast.success('Non-billable warranty ticket created');
      onSuccess();
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : detail?.message ? `${detail.message}${detail.conflicts?.length ? ': ' + detail.conflicts.join(', ') : ''}` : 'Unable to create ticket. Check the details and try again.');
    } finally { setSaving(false); }
  };
  return (
    <Dialog open onOpenChange={(open) => { if (!open && !saving) onClose(); }}>
      <DialogContent data-testid="warranty-ticket-modal" className="warranty-dialog">
        <DialogHeader>
          <DialogTitle data-testid="warranty-ticket-title">New warranty ticket</DialogTitle>
          <DialogDescription data-testid="warranty-ticket-customer" className="text-white break-words">{rollout.customer_name} · Non-billable</DialogDescription>
        </DialogHeader>
        <p className="text-sm break-words" data-testid="warranty-ticket-rollout">Original rollout: {rollout.description}</p>
        <form onSubmit={submit} className="space-y-4">
          <label className="block">Issue
            <textarea name="description" data-testid="warranty-ticket-description" className="retro-input w-full mt-1" rows={3} required maxLength={5000} value={form.description} onChange={change} />
          </label>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <label>Date<input name="appointment_date" data-testid="warranty-ticket-date" type="date" required className="retro-input w-full mt-1" value={form.appointment_date} onChange={change} /></label>
            <label>Priority<select name="priority" data-testid="warranty-ticket-priority" className="retro-input w-full mt-1" value={form.priority} onChange={change}>{['Low', 'Medium', 'High', 'Urgent'].map(p => <option key={p}>{p}</option>)}</select></label>
            <label>Start time<input name="start_time" data-testid="warranty-ticket-start" type="time" required className="retro-input w-full mt-1" value={form.start_time} onChange={change} /></label>
            <label>End time<input name="end_time" data-testid="warranty-ticket-end" type="time" required className="retro-input w-full mt-1" value={form.end_time} onChange={change} /></label>
          </div>
          <label className="block">Work type<select name="work_type" data-testid="warranty-ticket-work-type" className="retro-input w-full mt-1" value={form.work_type} onChange={change}><option value="remote">Remote</option><option value="onsite">On-site</option><option value="offsite">Offsite</option></select></label>
          {error && <p role="alert" data-testid="warranty-ticket-error" className="text-red-300 text-sm">{error}</p>}
          <div className="flex flex-wrap gap-3">
            <button type="submit" data-testid="warranty-ticket-submit" disabled={saving} className="retro-btn retro-btn-green flex-1">{saving ? 'Creating…' : 'Create ticket'}</button>
            <button type="button" data-testid="warranty-ticket-cancel" disabled={saving} onClick={onClose} className="retro-btn flex-1">Cancel</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};